// 'idle' | 'pending' | 'succeeded' | 'failed'
export const StatusData = {
  idle: "idle",
  pending: "pending",
  succeeded: "succeeded",
  failed: "failed"
};
